"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityComponents = exports.OpportunityModels = void 0;
const note_form_1 = __importDefault(require("./note-form"));
const opportunity_1 = require("./opportunity");
const opportunity_progress_1 = require("./opportunity-progress");
const opportunity_state_1 = require("./opportunity-state");
const state_form_1 = __importDefault(require("./state-form"));
exports.OpportunityModels = [
    opportunity_1.OpportunityModel,
];
exports.OpportunityComponents = [
    opportunity_state_1.OpportunityState,
    opportunity_progress_1.OpportunityProgress,
    state_form_1.default,
    note_form_1.default,
];
